export default __webpack_public_path__ + "files/code_themes/0b0b66a0ae6937473de35514f33d0980.css";